import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImage } from '@ifeng-fe/public_method';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const Relate = ({ content, relateTitleImage }) => {
    return (
        <div className={styles.relate}>
            <Chip id="260873" title="相关报道专区标题图" groupName="中国力量" type="struct">
                <div className={styles.relateTitle}>
                    <img src={relateTitleImage} />
                </div>
            </Chip>
            <Chip id="288429" title="相关报道" groupName="中国力量" type="recommend">
                <div className={styles.relateBox}>
                    {content.map((item, index) => {
                        const imageUrl = item?.thumbnail || item?.thumbnails?.image?.[0]?.url || '';
                        const newsTime = item?.newsTime?.split(' ')?.[0];

                        return (
                            <a href={item.url} key={index} rel="noreferrer" target="_blank" className={styles.relateItem}>
                                {imageUrl && <img className={styles.relateItemPic} src={formatImage(imageUrl, 138, 90)} />}
                                <div className={styles.relateItemText}>
                                    <div className={styles.relateItemTitle}>{item.title}</div>
                                    <div className={styles.relateItemTime}>{newsTime}</div>
                                </div>
                            </a>
                        );
                    })}
                </div>
            </Chip>
        </div>
    );
};

Relate.propTypes = {
    content: PropTypes.array,
    relateTitleImage: PropTypes.string,
};

export default errorBoundary(Relate);
